const ENDPOINT = 'GETownersreport';
function getOwnersReport(gateway, params = {}) {
    return gateway.get(getOwnersReport.endpoint, params);
}
getOwnersReport.endpoint = ENDPOINT;

export { getOwnersReport as default };
//# sourceMappingURL=getOwnersReports.js.map
